import { LowerCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { PlanDto } from '@workspace/data-types';
import { BaseDataTableCoreComponent, DataTableComponent, LuxonDatePipe } from '@workspace/ng-aura';
import { PriceDisplayPipe } from '@workspace/ng-data-access';
import { PlanColumnKey } from './abstract-plans-data-table.component';
import { PlansDataTableFilterCoreComponent } from './filter/plans-data-table-filter.component';

@Component({
  selector: 'core-plans-data-table',
  templateUrl: './plans-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    LowerCasePipe,
    PriceDisplayPipe,
    MatIconModule,
    MatTooltipModule,
    PlansDataTableFilterCoreComponent,
    RouterModule,
  ],
})
export class PlansDataTableCoreComponent extends BaseDataTableCoreComponent<PlanDto, PlanColumnKey> {}
